import createAction from '../services/create-action';

export const CLEAR_MEMBERS = 'member/CLEAR';

export default createAction(CLEAR_MEMBERS);



// WEBPACK FOOTER //
// ./app/actions/clear-members.js